<template>
    <md-field v-bind:class="{'md-invalid': !!errors}" class="phone-field">
        <label v-if="showLabel">{{ label }}</label>
        <!-- <span class="md-prefix"> -->
            <md-menu md-direction="bottom-start" class="shrink-0">
                <md-button md-menu-trigger>
                    {{ ((selectedCountry && countriesMap[selectedCountry]) ? countriesMap[selectedCountry].callingCode : '') }}
                    <custom-icon name="arrow_drop_down" />
                </md-button>

                <md-menu-content>
                    <md-menu-item v-for="country in countries" :key="country.idPays" @click="selectedCountry=country.idPays" :dusk="'phone_country_' + country.isoCode">{{ country.isoCode + ' (' + country.callingCode + ')' }}</md-menu-item>
                </md-menu-content>
            </md-menu>
        <!-- </span> -->
        <md-input :placeholder="showLabel ? null : label" :name="name" v-model="useValue" v-on:blur="wasFocused = true" :disabled="disabled" :required="required" type="tel" autocomplete="tel"></md-input>
        <span class="md-error">{{ errors ? errors[0] : '' }}</span>
    </md-field>
</template>

<script>
    import { parseNumber, formatNumber, AsYouType, isValidNumber } from 'libphonenumber-js';
    import { parsePhoneNumber } from 'libphonenumber-js/max';

    export default {
        props: {
            name: String,
            value: String,
            errors: Array,
            label: String,
            countryId: String,
            disabled: String,
            required: Boolean,
            showLabel: {
                type: Boolean,
                default: true,
            },
            mobileOnly: {
                type: Boolean,
                default: false,
            }
        },
        watch: {
            value(v) {
                if (v === '') {
                    this.phoneInputValue = '';
                }
            }
        },
        data() {
            return {
                countries: [],
                countriesMap: {},
                theSelectedCountry: this.countryId,
                phoneInputValue: ''
            }
        },
        mounted() {
            this.$root.getCountries().then(countries => {
                countries.forEach(country => {
                    if (country.isoCode && country.callingCode) {
                        this.countries.push(country);
                        this.countriesMap[country.idPays] = country;
                    }
                });
                this.processValue();
            });
        },
        computed: {
            useValue: {
                get() {
                    if (!this.phoneInputValue) {
                        if (this.value === null) {
                            this.phoneInputValue = '';
                        } else {
                            var parsedNumber = parseNumber(this.value);
                            if (parsedNumber.phone) {
                                this.phoneInputValue = parsedNumber.phone;
                            } else {
                                this.phoneInputValue = this.value;
                            }
                        }
                        this.processValue();
                    }
                    return this.phoneInputValue;
                },
                set(value) {
                    this.phoneInputValue = value;
                    this.processValue();
                }
            },
            selectedCountry: {
                get() {
                    return this.theSelectedCountry;
                },
                set(country) {
                    this.theSelectedCountry = country;
                    this.processValue();
                }
            }
        },
        methods: {
            processValue() {
                if (this.selectedCountry && this.countriesMap[this.selectedCountry]) {
                    var parsedNumber = parseNumber(this.phoneInputValue, this.countriesMap[this.selectedCountry].isoCode);
                    if (parsedNumber.country) {
                        var newCountry = Object.values(this.countries).filter(c => c.isoCode === parsedNumber.country);
                        if (newCountry.length == 1) {
                            newCountry = newCountry[0].idPays;
                            if (newCountry != this.selectedCountry) {
                                this.selectedCountry = newCountry;
                            }
                        }
                        var formattedNumber = formatNumber({country: parsedNumber.country, phone: parsedNumber.phone}, 'International');
                        if (isValidNumber(formattedNumber)) {
                            if (this.mobileOnly && parsePhoneNumber(parsedNumber.phone, parsedNumber.country).getType() !== 'MOBILE') {
                                this.phoneInputValue = this.phoneInputValue.replace(/ /g, '');
                                this.$emit('input', this.phoneInputValue);
                            } else {
                                this.phoneInputValue = formattedNumber.substring(this.countriesMap[this.selectedCountry].callingCode.length).trim();
                                this.$emit('input', formattedNumber);
                                this.$emit('valid', formattedNumber);
                            }
                        } else {
                            this.phoneInputValue = this.phoneInputValue.replace(/ /g, '');
                            this.$emit('input', this.phoneInputValue);
                        }
                    } else {
                        this.phoneInputValue = this.phoneInputValue.replace(/ /g, '');
                        this.$emit('input', this.phoneInputValue);
                    }
                } else {
                    this.phoneInputValue = this.phoneInputValue.replace(/ /g, '');
                    this.$emit('input', this.phoneInputValue);
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/widgets/PhoneFieldComponent.vue